export const mapBackendToForm = (data) => {
  if (!data) return null;

  const formatDateTime = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    return isNaN(date.getTime()) ? "" : date.toISOString().slice(0, 16);
  };

  return {
    ...data,
    order_datetime: formatDateTime(data.order_datetime),
  };
};

export const mapFormToBackend = (formData) => {
  const formatDateTime = (input) => {
    if (!input) return null;
    const date = new Date(input);
    if (isNaN(date)) return null;
    return date.toISOString().slice(0, 19).replace("T", " ");
  };

  return {
    ...formData,
    order_datetime: formatDateTime(formData.order_datetime),
  };
};
